import React from "react";

export default function EmptyListIndicator({ text }) {
  return (
    <div
      className="bg-light80 d-flex align-items-center justify-content-center rounded fw-bolder text-light20"
      style={{ height: "150px" }}
    >
      {text}
    </div>
  );
}
